export const TagPicker = ({ options = [], value = [], onChange, testid = "tag-picker" }) => {
  const toggle = (t) => onChange(value.includes(t) ? value.filter((x) => x !== t) : [...value, t]);
  if (!options.length) return <p className="text-xs text-muted-foreground">No service tags yet — add them in Settings.</p>;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testid}>
      {options.map((t) => (
        <button type="button" key={t} onClick={() => toggle(t)} data-testid={`${testid}-${t}`}
          className={`px-2.5 py-1 rounded-full text-xs font-medium border transition-colors ${value.includes(t) ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary/50"}`}>
          {t}
        </button>
      ))}
    </div>
  );
};
